import React from 'react';
import { Dismiss20Regular, Mail16Regular, Copy16Regular, Call16Regular, Chat16Regular } from '@fluentui/react-icons';
import { toast } from 'react-toastify';
import TentAvatar from './TentAvatar';
import { formatLocalTime, getEffectiveLocation, getEffectiveTimezone } from '../../utils/tentTimezoneUtils';
import styles from './css/index.module.css';

const MemberDetailPanel = ({ member, onClose, onEmail, onMessage }) => {
    if (!member) return null;

    const timezone = getEffectiveTimezone(member);
    const location = getEffectiveLocation(member) || '—';
    const localTime = formatLocalTime(timezone);

    const copyText = async text => {
        if (!text) return;
        try {
            await navigator.clipboard.writeText(text);
            toast.success('Copied to clipboard');
        } catch {
            toast.error('Failed to copy');
        }
    };

    return (
        <>
            <div className={styles.panelOverlay} onClick={onClose} />
            <aside className={styles.panelDrawer}>
                <div className={styles.panelHeader}>
                    <div className={styles.panelHeaderTop}>
                        <div className={styles.panelIdentity}>
                            <span className={styles.panelAvatarWrap}>
                                <TentAvatar name={member.full_name} size={40} margin="0" />
                            </span>
                            <div>
                                <h2 className={styles.panelName}>{member.full_name}</h2>
                                <p className={styles.panelMeta}>{member.job_title || '—'}</p>
                                <p className={styles.panelOrg}>{member.organisation || '—'}</p>
                            </div>
                        </div>
                        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
                            <Dismiss20Regular />
                        </button>
                    </div>
                    <div className={styles.panelActions}>
                        <button type="button" className={styles.primaryButton} onClick={() => onEmail([member])}>
                            <Mail16Regular />
                            Email
                        </button>
                        {onMessage ? (
                            <button type="button" className={styles.secondaryButton} onClick={() => onMessage(member)}>
                                <Chat16Regular />
                                Message
                            </button>
                        ) : null}
                        <button type="button" className={styles.secondaryButton} onClick={() => copyText(member.email)}>
                            <Copy16Regular />
                            Copy email
                        </button>
                    </div>
                </div>

                <section className={styles.panelSection}>
                    <p className={styles.sectionLabel}>Project Involvement</p>
                    <div style={{ marginBottom: 12 }}>
                        <p className={styles.fieldLabel}>Workstreams</p>
                        <div className={styles.pillRow}>
                            {(member.workstreams || []).length ? (
                                member.workstreams.map(ws => (
                                    <span key={ws} className={styles.pill}>
                                        {ws}
                                    </span>
                                ))
                            ) : (
                                <span className={styles.fieldValue}>—</span>
                            )}
                        </div>
                    </div>
                    <div style={{ marginBottom: 12 }}>
                        <p className={styles.fieldLabel}>Department</p>
                        <p className={styles.fieldValue}>{member.department || '—'}</p>
                    </div>
                    {(member.responsibilities || []).length > 0 && (
                        <div>
                            <p className={styles.fieldLabel}>Responsibilities</p>
                            <ul className={styles.responsibilityList}>
                                {member.responsibilities.map(item => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </section>

                <section className={styles.panelSection}>
                    <p className={styles.sectionLabel}>Contact</p>
                    <div style={{ marginBottom: 16 }}>
                        <p className={styles.fieldLabel}>Email</p>
                        <p className={styles.fieldValue}>{member.email}</p>
                        <div className={styles.inlineActions}>
                            <button type="button" className={styles.smallButton} onClick={() => onEmail([member])}>
                                <Mail16Regular />
                                Email
                            </button>
                            <button type="button" className={styles.smallButton} onClick={() => copyText(member.email)}>
                                <Copy16Regular />
                                Copy
                            </button>
                        </div>
                    </div>
                    {member.phone ? (
                        <div>
                            <p className={styles.fieldLabel}>Phone</p>
                            <p className={styles.fieldValue}>{member.phone}</p>
                            <div className={styles.inlineActions}>
                                <a href={`tel:${member.phone}`} className={styles.smallButton}>
                                    <Call16Regular />
                                    Call
                                </a>
                                <button type="button" className={styles.smallButton} onClick={() => copyText(member.phone)}>
                                    <Copy16Regular />
                                    Copy
                                </button>
                            </div>
                        </div>
                    ) : null}
                </section>

                <section className={styles.panelSection}>
                    <p className={styles.sectionLabel}>Location</p>
                    <div style={{ marginBottom: 12 }}>
                        <p className={styles.fieldLabel}>Working location</p>
                        <p className={styles.fieldValue}>{location}</p>
                    </div>
                    <div>
                        <p className={styles.fieldLabel}>Local time</p>
                        <p className={styles.fieldValue}>{localTime}</p>
                    </div>
                </section>
            </aside>
        </>
    );
};

export default MemberDetailPanel;
